import { useMemo } from 'react';

import useTrainingStore from '../stores/useTrainingStore';
import { buildTrainingMatrix, TTrainingMatrix } from '../utils/trainingMatrix';
import useResolvedTraining from './useResolvedTraining';

// The resolved QM training matrix, including the live assign/confirm demo state -
// or undefined when the training mock is not enabled for the organization.
const useTrainingMatrix = (): TTrainingMatrix | undefined => {
  const training = useResolvedTraining();
  const isActive = useTrainingStore((state) =>
    training ? state.activeDocumentIds.includes(training.documentId) : false
  );
  const assignment = useTrainingStore((state) => state.assignment);
  const completion = useTrainingStore((state) => state.completion);

  // useResolvedTraining returns a fresh object each render; key the memo on the config.
  const trainingKey = JSON.stringify(training);

  return useMemo(
    () =>
      training
        ? buildTrainingMatrix(training, {
            isActive,
            assignedDueDate: assignment?.dueDate,
            completedBy: completion?.completedBy,
            completedAt: completion?.completedAt,
          })
        : undefined,
    // eslint-disable-next-line react-hooks/exhaustive-deps -- training is keyed by trainingKey
    [trainingKey, isActive, assignment, completion]
  );
};

export default useTrainingMatrix;
